import { getApiClient } from "../../utils/Api";
import { getCenter } from "../selectors/search";
import { omitBy, isNil } from "lodash";
import { getLocale } from "../selectors/ui";

export const ActionTypes = {
  SEARCH_SUCCESS: "kikudoo/search/success",
  SEARCH_REQUEST: "kikudoo/search/request",
  SEARCH_FAILED: "kikudoo/search/failed",
  SEARCH_CLEARED: "kikudoo/search/cleared",
  ADDRESS_CHANGED: "kikudoo/search/change_address",
  ADDRESS_CLEARED: "kikudoo/search/clear_address",
  LIST_VIEW_CHANGED: "kikudoo/list_view/changed",
  COURSE_SEARCH_SUCCESS: "kikudoo/course_search/success",
  SET_FILTERS: "kikudoo/filters/set",
  SET_FILTER: "kikudoo/filter/set",
};

export const changeAddress = (address, lat, lng) => ({
  type: ActionTypes.ADDRESS_CHANGED,
  payload: {
    address,
    lat,
    lng,
  },
});

export const changeListView = state => ({
  type: ActionTypes.LIST_VIEW_CHANGED,
  payload: state,
});

export const clearAddress = (address, lat, lng) => ({
  type: ActionTypes.ADDRESS_CLEARED,
});

const searchRequest = locations => ({
  type: ActionTypes.SEARCH_REQUEST,
  payload: locations,
});

const searchFailed = () => ({
  type: ActionTypes.SEARCH_FAILED,
});

const searchSuccess = result => ({
  type: ActionTypes.SEARCH_SUCCESS,
  payload: result,
});

const courseSearchSuccess = result => ({
  type: ActionTypes.COURSE_SEARCH_SUCCESS,
  payload: result,
});

// Dropping a search drops the requests still answering it. The map and the result list search
// different endpoints into the same slice, so a response that outlives the page it was asked
// for lands on the one that replaced it.
export const clearSearch = () => dispatch => {
  getApiClient().cancelRequest();

  dispatch({ type: ActionTypes.SEARCH_CLEARED });
};

// The map needs every offering in view rather than a page of them, so it searches the
// uncapped locations endpoint instead of the paginated one the result list uses.
export const searchMapResults = (term = "", searchCenter = null, filters = {}) => async (
  dispatch,
  getState,
) => {
  const center = searchCenter || getCenter(getState());
  if (!center) {
    return dispatch(searchFailed());
  }

  dispatch(searchRequest(true));

  return getApiClient()
    .searchLocations(term, { ...center, ...omitBy(filters, isNil) })
    .then(result => {
      // If result is undefined, the request got canceled
      if (!result) {
        return;
      }

      dispatch(searchSuccess(result));
    })
    .catch(e => {
      dispatch(searchFailed());
      throw e;
    });
};

export const searchCourses = (
  term = "",
  page = 1,
  searchCenter = null,
  filters = { flexibleLocation: false },
) => async (dispatch, getState) => {
  dispatch(searchRequest(false));

  return getApiClient()
    .search(term, page, {
      ...(searchCenter || {}),
      ...omitBy(filters, isNil),
    })
    .then(result => {
      // If result is undefined, the request got canceled
      if (!result) {
        return;
      }
      dispatch(courseSearchSuccess(result));
    })
    .catch(e => {
      dispatch(searchFailed());
      throw e;
    });
};

export const searchByText = query => async (dispatch, getState) => {
  return getApiClient().searchText({ text_search: { query, locale: getLocale(getState()) } });
};

export const setFilters = filters => ({
  type: ActionTypes.SET_FILTERS,
  payload: filters,
});

export const setFilter = filter => ({
  type: ActionTypes.SET_FILTER,
  payload: filter,
});
